export const createModalRoot = (rootName: string = 'modal-root') => {
  let modalRoot = document.getElementById(rootName);
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.setAttribute('id', rootName);
    document.body.appendChild(modalRoot);
  }
};
